import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll the viewport to the top whenever the route changes.
 * Mounted once inside the Router so every navigation triggers this.
 * Hash navigations (#archive, #pulse, etc.) are left alone so anchor jumps still work.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let anchor links behave naturally
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}
